// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2Ifso","large":"styles_large__2G2iO"};